import { marked } from "marked"
import { sanitizeText } from "../utils"
import { html } from "lit-html"
import { unsafeHTML } from "lit-html/directives/unsafe-html"

// We're using a more limited markdown parser that doesn't include paragraph tags, so
// we're implementing our own splitting on 2 newlines here
export default function (md, appendElement = null) {
  const lines = md.split("\n\n").filter((line) => !!line.trim())

  const paragraphs = lines.map((line, index) => {
    const isLastParagraph = index === lines.length - 1
    return html`<p>
      ${unsafeHTML(marked.parseInline(sanitizeText(line)))}
      ${isLastParagraph ? appendElement || "" : ""}
    </p>`
  })

  return paragraphs
}
